export default "__VITE_ASSET__CkvvwgqS__"